"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postNotification = postNotification;
exports.removeNotification = removeNotification;

var _ActionTypes = _interopRequireDefault(require("./ActionTypes"));

function postNotification(notification) {
  return {
    type: _ActionTypes.default.ADD_NOTIFICATION,
    payload: notification
  };
}

function removeNotification(id) {
  return {
    type: _ActionTypes.default.REMOVE_NOTIFICATION,
    payload: {
      id: id
    }
  };
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ReduxMessenger/static-2.3840/js/actions/NotificationActions.js
// module id = 239
// module chunks = 209 210 211 212